import React, { useState } from 'react';
import { get, isObject, isNil } from 'lodash';
import { Field } from 'redux-form';

import APIClient from '../../../../common/services/APIClient';
import countries from '../../../../common/constants/ISOCountriesCodes';
import RenderGooglePlaceAutocomplete from '../../../../common/components/Form/RenderGooglePlaceAutocomplete';

export const renderGooglePlaceAutocomplete = (field, props) => {
  const [placePredictions, setPlacePredictions] = useState([]);

  const onBlur = (event, newValue) => {
    props.change(field.name, newValue);
  };
  const onFocus = () => {
    if (!props.c_country) {
      props.touch('c_identity.c_address');
    }
  };
  const onItemSelected = (value, geometry) => {
    const { change } = props;

    if (isObject(value)) {
      APIClient.get(`/geolocation/${value.value}`).then((response) => {
        const result = get(response, 'data');

        if (response.status === 200) {
          const locationPickerMarkerContryNames = result.addressComponents.find((item) => item.types.includes('COUNTRY'));

          change('_google_api_country_names', locationPickerMarkerContryNames);

          const { lat } = result.geometry.location;
          const { lng } = result.geometry.location;
          // We receive utc_offset in minutes so value need to be divided by 60
          const utcOffset = !isNil(result.utcOffset) ? result.utcOffset / 60 : '';

          change('c_identity.c_latitude', get(geometry, 'lat', lat));
          change('c_identity.c_longitude', get(geometry, 'lng', lng));
          change('c_identity.c_utc', utcOffset);
          change('c_identity.place_id', value.value);
        }
      });
    }
  };
  const onUpdateInputFromPicker = (marker, geometry) => {
    const { change } = props;

    if (marker) {
      const locationPickerMarkerCountryNames = marker.address_components
        .find((item) => item.types.includes('country') || item.types.includes('COUNTRY'));

      change('_google_api_country_names', locationPickerMarkerCountryNames);

      if (marker.place_id) {
        onItemSelected({ value: marker.place_id }, geometry);
      } else if (marker.geometry) {
        const lat = marker.geometry.location.lat();
        const lng = marker.geometry.location.lng();

        change('c_identity.c_latitude', get(geometry, 'lat', lat));
        change('c_identity.c_longitude', get(geometry, 'lng', lng));
        change('c_identity.c_utc', '');
      }
    }
  };
  const onUpdateInput = (searchText, isValidAdress) => {
    if (!isValidAdress) {
      const { change } = props;

      change('c_identity.c_latitude', null);
      change('c_identity.c_longitude', null);
      change('c_identity.c_utc', null);
    }

    const predictionsReceiveHandler = (predictions, status) => {
      if (status === 200) {
        const placePredictionDataSource = predictions.map((prediction) => ({
          text: prediction.description,
          value: prediction.placeId,
        }));

        setPlacePredictions(placePredictionDataSource);
      }
    };

    if (searchText === '') {
      setPlacePredictions([]);

      return;
    }

    const componentRestrictions = {};
    const selectedCountry = props.c_country;

    if (selectedCountry) {
      const country = countries.find(
        (item) => item.name.toLowerCase() === selectedCountry.toLowerCase() || item['alpha-2'].toLowerCase() === selectedCountry.toLowerCase(),
      );

      if (country) {
        componentRestrictions.country = country['alpha-2'].toLowerCase();
      }
    }

    const countryParam = componentRestrictions.country ? componentRestrictions.country : '';

    APIClient.get(`/geolocation/predictions?isoCountryCode=${countryParam}&address=${encodeURIComponent(searchText)}`).then((response) => {
      predictionsReceiveHandler(response.data, response.status);
    });
  };

  const countrySelectionFirst = field.countryIsRequired && !props.c_country;
  const readOnly = field.readOnly || countrySelectionFirst;
  const label = countrySelectionFirst ? <span>{field.floatingLabelText}</span> : field.floatingLabelText;

  return (
    <Field
      required={field.starred}
      key={field.name}
      name={field.name}
      readOnly={readOnly}
      onItemSelected={onItemSelected}
      onUpdateInputFromPicker={onUpdateInputFromPicker}
      className={field.className}
      dataSource={placePredictions}
      onUpdateInput={onUpdateInput}
      countrySelected={props.c_country}
      c_latitude={props.c_latitude}
      c_longitude={props.c_longitude}
      c_address={props.c_address}
      place_id={props.place_id}
      component={RenderGooglePlaceAutocomplete}
      floatingLabelText={label}
      validate={field.validate}
      fullWidth
      onFocus={onFocus}
      onBlur={onBlur}
    />
  );
};
